'use strict';

var base = require('./base');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            $('.product-details').empty().html(data.product.attributesHtml);
            var $addToCart = $('.button-add');
            var $goToCart = $('.button-cart');
            if (data.productAlreadyInCart) {
                $addToCart.addClass('d-none');
                $goToCart.removeClass('d-none');
            } else {
                $addToCart.removeClass('d-none');
                $goToCart.addClass('d-none');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available)
            );
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '.pdp-copy-url', function (event) {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('.share-product-link').val()).select();
            document.execCommand('copy');
            $temp.remove();
            var copiedMsg = $('.urlCopiedText').val();
            $('body').trigger('successToast', copiedMsg);
        });
    },
    copyCouponCode: function () {
        $('.coupon-code-btn').on('click', function () {
            var couponCopiedMessage = $('.coupon-copied').val();
            navigator.clipboard.writeText($(this).val());
            $('body').trigger('successToast', couponCopiedMessage);
        });
    },
    viewStickyProductDetails: function () {
        var button = $('.prices-add-to-cart-actions .cart-and-ipay');
        if (button.length > 0) {
            $(window).scroll(function () {
                var buttonTop = button.offset().top;
                var scrollTop = $(this).scrollTop();

                if (scrollTop > buttonTop) {
                    $('.product-sticky').addClass('d-lg-flex');
                } else {
                    $('.product-sticky').removeClass('d-lg-flex');
                }
            });
        }
    },

    handlePriceBreakupLink: function () {
        $('body').on('click', '.price-breakup-cta', function (e) {
            e.preventDefault();
            $('#priceBreakupTab').trigger('click');
            var priceBrakupTab = $('body').find('#priceBreakupTab');
            var position = priceBrakupTab && priceBrakupTab.length ? priceBrakupTab.offset().top - $('.header').outerHeight(true) : 0;
            $('html, body').animate({
                scrollTop: position
            }, 500);
            priceBrakupTab.trigger('click');
        });
    },

    handleShare: function () {
        $('body').on('click', '.pdp-share', function (e) {
            e.preventDefault();
            const isMobile = $(window).width() < 1024;
            const canNativeShare = !!navigator.share;
            if (isMobile && canNativeShare) {
                const metaDescription = $('meta[name="description"]').attr('content') || '';
                navigator.share({
                    title: document.title,
                    text: metaDescription,
                    url: window.location.href
                });
            } else {
                $('#socialShareModel').modal('show');
            }
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
